// extracted by mini-css-extract-plugin
export var featuredArticle = "featuredArticle-module--featuredArticle--wSpaJ";
export var image = "featuredArticle-module--image--SQR1w";
export var category = "featuredArticle-module--category--LI7R3";
export var author = "featuredArticle-module--author--jzG35";
export var title = "featuredArticle-module--title--Qi79Y";
export var description = "featuredArticle-module--description--i0zqd";
export var slideUp = "featuredArticle-module--slideUp--Q2Z77";
export var slideUpLarge = "featuredArticle-module--slideUpLarge--FIxy6";